export default __webpack_public_path__ + "static/media/eco_thumbnail_mobile.d7c43b17.webp";